export function getText(payment) {
  return `with check${payment.check_number ? ` ${payment.check_number}` : ''}${payment.payer_name ? ` (${payment.payer_name})` : ''}`
}
